module.exports = __webpack_public_path__ + "static/logo064e2384edac206421f36db1b53ac3ed.png";